import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Footer from '../components/footer'
import Header from '../components/header'
import './index.css'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'title', content: 'Ultras Mundial, Racismo en la otra cara del Mundial de Rusia 2018' },
        { name: 'description', content: 'Conoce a través de varios capítulos la otra cara que trae la Copa Mundial de Rusia 2018. Una serie de episodios para seguir la problemática de los ultras, el racismo y la violencia en el Mundial.' },
        { name: 'keywords', content: 'ultras, ultras mundial, racismo, mundial, mundial de rusia, mundial rusia 2018, ultras rusia, racismo mundial rusia, violencia mundial rusia' },
        { name: 'og:title', content: 'Ultras, violencia y racismo: la otra cara del Mundial de Rusia' },
        { name: 'og:description', content: 'La designación de Rusia como sede del Mundial 2018 sigue siendo controvertida. Se apoyó un fútbol que tiene los grupos ultras más temidos de Europa y en cuyas canchas impera el racismo y la homofobia.' },
        { name: 'og:image', content: 'https://cdn4.uvnimg.com/f5/41/b62992a24e6aab94cd3a4a293a42/portada.jpg' },
        { name: 'og:url', content: `https://www.univision.com${process.env.PREFIX_PATH}` },
        { name: 'twitter:title', content: 'Ultras, violencia y racismo: la otra cara del Mundial de Rusia' },
        { name: 'twitter:description', content: 'La designación de Rusia como sede del Mundial 2018 sigue siendo controvertida. Se apoyó un fútbol que tiene los grupos ultras más temidos de Europa y en cuyas canchas impera el racismo y la homofobia.' },
        { name: 'twitter:image', content: 'https://cdn4.uvnimg.com/f5/41/b62992a24e6aab94cd3a4a293a42/portada.jpg' },
        { name: 'twitter:card', content: 'summary_large_image' },
        
      ]}
    />
    <Header Pages={data.allSitePage.edges}/>
    <div
      style={{
        
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    allSitePage{
      edges {
        node {
          id
          path
          context 
          {
            slug
            node{
              title
              label
              description
              publishDate
              type
              index
              author_name
              author_image
            }
          }
        }
      }
    }
  }`


// WEBPACK FOOTER //
// ./src/layouts/index.js